module.exports = __webpack_public_path__ + "img/gl1.3b4f1012.jpg";